export default {
  GroupCode: "",
  GroupName: "",
  ParentGroupId: null,
  Level: 1,
  IsActive: true,
  UserModified: localStorage.getItem("UserName"),
};
